// @ts-strict-ignore
import { ArticleVO } from '@article/model/vo/article.vo';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';

export class ArticlePreviewUtils {
  public static getPreviewImage(article: ArticleVO): string {
    if (!article) {
      return null;
    }
    return this.getPreviewImageByNo(article.articleNo);
  }

  public static getPreviewImageByNo(articleNo: string): string {
    if (!articleNo) {
      return null;
    }
    return '/assets/productimages/' +  articleNo.replace('/', '_') + '.jpg';
  }

  public static openShopLink(articleNo: string, localeResourceManager: LocaleResourceManager) {
    if (!articleNo) {
      return;
    }
    window.open(localeResourceManager.getValueByKey(`link.info_wago_web_side`, { 0: articleNo }), `_blank`);
  }

}
